import React from "react";
import { Checkbox, Col, Form, Input, Row, Select } from "antd";
import { propertyTypes } from "../../../../../utils/NewPropertyHelper";
import { states } from "../../../../../utils/Util";

function PropertyNameAndAddress({ setPropertyType }) {
  return (
    <>
      <Form.Item
        name="propertyType"
        label="Property Type"
        required
        rules={[
          {
            required: true,
            message: "Please select property type",
          },
        ]}
      >
        <Select
          options={propertyTypes}
          onChange={(value) => setPropertyType(value)}
        />
      </Form.Item>
      <Form.Item name="propertyName" label="Property Name" rules={[
          {
            required: true,
            message: "Please enter property name",
          },
        ]}>
        <Input />
      </Form.Item>
      <Form.Item
        name="propertyAddressOne"
        label="Address"
        required
        rules={[
          {
            required: true,
            message: "Please select property address",
          },
        ]}
      >
        <Input placeholder="Address 1" />
      </Form.Item>
      <Form.Item name="propertyAddressTwo" label=" ">
        <Input placeholder="Address 2" />
      </Form.Item>
      <Form.Item label="City" required>
        <Row>
          <Col flex={10}>
            <Form.Item name="city" rules={[{ required: true }]}>
              <Input placeholder="City" />
            </Form.Item>
          </Col>
          <Col flex={1}></Col>
          <Col flex={2}>
            <Form.Item name="state">
              <Select options={states} />
            </Form.Item>
          </Col>
          <Col flex={1}></Col>
          <Col flex={2}>
            <Form.Item
              name="zipCode"
              help="ZIP code must be either 5 or 10 characters long"
            >
              <Input placeholder="Zip" minLength={5} maxLength={10} />
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item label="Country" name="country">
        <Input placeholder="Country" />
      </Form.Item>
      <Form.Item
        label="Affordable Housing Property"
        name="affordableHousingProperty"
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox></Checkbox>
      </Form.Item>
    </>
  );
}

export default PropertyNameAndAddress;
